import { 
  Component, 
  OnInit, 
  Input, 
  Output, 
  EventEmitter, 
  ChangeDetectionStrategy, 
  ChangeDetectorRef} from '@angular/core';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { DomSanitizer } from '@angular/platform-browser';
import { StoryChapterThumbnail } from 'src/app/story/models/story-chapter-thumbnail.model';
import * as _ from 'lodash';

@Component({
  selector: 'app-chapter-card',
  templateUrl: './chapter-card.component.html',
  styleUrls: ['./chapter-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChapterCardComponent implements OnInit {
  @Input()
  public get chapter(): ChapterModel {
    return this._chapter;
  }
  public set chapter(value: ChapterModel) {
    this._chapter = value;
  }
  private _chapter: ChapterModel;

  @Input()
  selected: boolean;

  @Input()
  canRemove = true;

  @Input()
  public get thumbnail(): StoryChapterThumbnail {
    return this._thumbnail;
  }
  public set thumbnail(value: StoryChapterThumbnail) {
    this._thumbnail = value;
  }
  private _thumbnail: StoryChapterThumbnail;

  @Output()
  duplicate = new EventEmitter<ChapterModel>();

  @Output()
  remove = new EventEmitter<ChapterModel>();

  public get shortDescription() {
    const length = 48;

    const description = _.get(this.chapter, 'info.description') || '';
    if (description.length <= length) {
      return description;
    }

    return description
      .replace('<br>', '')
      .substr(0, length - 3) + '...';
  }

  constructor(
    private sanitizer: DomSanitizer,
    private changeDetection: ChangeDetectorRef
  ) { }

  ngOnInit() {}

  // return css block for image
  getImageStyle(): any {
    // use snapshot if present, otherwise use small
    if (!!this.thumbnail) {
      const url = (this.thumbnail.snapshot) ? this.thumbnail.snapshot : this.thumbnail.urls.small;
      return {
        'background-image': `url(${url})`,
        'background-size': 'cover'
      };
    } else {
      return {};
    }
  }

  handleDuplicateClick() {
    this.duplicate.emit(this.chapter);
  }

  handleRemoveClick() {
    this.remove.emit(this.chapter);
  }
}
